import './http.js'
import { removeCookie } from 'tiny-cookie'
import { getIndex, by, subArg, generateUrl, getIdArray, isAdBlock } from '@common/js/common'
import router from '../router'
import moment from 'moment'
import XLSX from 'xlsx'
export default {
  install(Vue) {
    Vue.prototype.getIndex = getIndex
    Vue.prototype.by = by
    Vue.prototype.generateUrl = generateUrl
    Vue.prototype.getIdArray = getIdArray
    Vue.prototype.subArg = subArg
    Vue.prototype.isAdBlock = isAdBlock

    Vue.prototype.changePageItem = function(page, data) {
      page.tot = data.tot
      page.from = (page.cur - 1) * page.per + 1
      page.to = parseInt(page.from) + parseInt(page.per) - 1
      if (page.to > page.tot) {
        page.to = page.tot
      }
    }

    Vue.prototype.Logout = function() {
      removeCookie('login')
      // removeCookie('campaign_new_user')
      
      this.$http.get('/api/accounts/logout/').then(() => {
        if (this.$store) {
          this.$store.dispatch('reset')
        }
        this.langLogin()
        // router.push({ name: 'login' })
      })
    }

    Vue.prototype.langLogin = function() {
      let str = this.$i18n ? this.$i18n.locale : 'en'
      if (str === 'zh') {
        router.push({ path: '/zh-cn/login' })
      } else {
        router.push({ path: '/en-us/login' })
      }
    }

    Vue.prototype.Login = function() {
      // router.push({ name: 'login' })
      this.langLogin()
    }

    // 通知窗口
    Vue.prototype.notifyOpen = function(title, msg, type, duration) {
      msg = msg || (type === 'success' || !type ? this.$t('messages.createCampaign.create155') : this.$t('messages.createCampaign.create156'))
      let newTitle = title === 'Success' ? this.$t('messages.createCampaign.create155') :
                    title === 'Error' ? this.$t('messages.createCampaign.create156') : title
      this.$notify({
        title: newTitle || this.$t('messages.createCampaign.create155'),
        message: msg,
        type: type || 'success',
        duration: duration !== undefined ? duration : type === 'success' || !type ? 5000 : 10000,
      })
    }

    // 确认窗口
    Vue.prototype.confirmOpen = function(
      msg = 'Are you sure?',
      success = () => {},
      error = () => {}
    ) {
      this.$confirm('', msg, {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true,
      })
        .then(success)
        .catch(error)
    }

    Vue.prototype.isFormValid = function(form) {
      let form_valid = false
      this.$refs[form].validate(valid => {
        if (valid) {
          form_valid = true
        }
      })
      return form_valid
    }

    Vue.prototype.onCopy = function() {
      this.notifyOpen(this.$t('messages.createCampaign.create159'))
    }

    Vue.prototype.setTitle = function(title) {
      document.title = title ? `${title} | ASOGrow` : 'ASOGrow'
    }

    // 重写selection结构
    Vue.prototype.initSelectOptions = (options = {}) => {
      const obj = []
      const arr = Object.keys(options)
      for (let i = 0; i < arr.length; i += 1) {
        let value = arr[i]
        let _value = Number(value)
        if (!isNaN(_value)) {
          value = _value
        }
        obj.push({
          id: value,
          name: options[arr[i]],
        })
      }
      return obj
    }

    Vue.prototype.formatData = function(data, format) {
      if (!data) {
        return '-'
      }
      if (!format) {
        return data
      }
      var result = data
      if (~format.indexOf(',')) {
        var temp = data.toString()
        var int_ = data
        var float_ = ''
        if (~temp.indexOf('.')) {
          // 浮点数分割
          var temp_array = temp.split('.')
          int_ = temp_array[0]
          float_ = temp_array[1]
        }
        result =
          int_.toString().replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,') + (float_ ? '.' + float_ : '')
      }
      if (~format.indexOf('$')) {
        result = '$' + result
      }
      return result
    }

    // 格式化日期
    Vue.prototype.formatDate = function(date, format) {
      let dateStr = ''
      format = format || 'YYYY-MM-DD'
      if (date) {
        dateStr = moment(date).format(format)
      }
      return dateStr
    }
    Vue.prototype.exportToCSV = function(csvData, fileName, bookType = 'xlsx') {
      // 将数据转换为工作簿对象
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(csvData)
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

      // 将工作簿转换为CSV字符串
      const csvOutput = XLSX.write(wb, { bookType, type: 'string' })

      // 创建Blob对象
      const blob = new Blob([csvOutput], { type: 'text/csv;charset=utf-8' })

      // 创建下载链接并模拟点击
      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(blob)
      downloadLink.download = fileName
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    }
    Vue.prototype.handleExcelData = function(res) {
      let arr1 = res.data
      let arr2 = res.title
      let newArr = arr1.map(item => {
        // 初始化一个空对象，用于存储转换后的属性
        let newObj = {}
        // 遍历arr2，按照其定义的顺序设置新对象的属性
        arr2.forEach(mapping => {
          newObj[mapping.name] = item[mapping.key] // 使用arr2中的name作为新对象的键，arr1中的值作为值
        })
        return newObj
      })
      return newArr
    }
    // 校验手机号
    Vue.prototype.validatePhone = function(rule, value, callback) {
      const phoneRegex = /^1[3-9]\d{9}$/ // 手机号正则表达式
      const regex = /\D/
      if (!phoneRegex.test(value)) {
        if (regex.test(value)) {
          return callback(new Error(this.$t('messages.register.phoneErr1')))
        } else {
          return callback(new Error(this.$t('messages.register.phoneErr2')))
        }
      } else {
        callback()
      }
    }

    // 拉起客服聊天窗口
    Vue.prototype.OpenTawkChat = function(page, data) {
      if(window.Tawk_API){
        // 1. 显示客服组件（若被隐藏）
        window.Tawk_API.showWidget();
       // 2. 强制打开聊天窗口（核心方法）
       window.Tawk_API.maximize(); 
     }
    }

    // // utils/validate.js
    Vue.prototype.createRequiredRule = function(vm, i18nKey, trigger = ['blur', 'change']) {
      return {
        required: true,
        trigger,
        validator: (rule, value, callback) => {
          if (!value || (value instanceof Array && value.length === 0)) {
            callback(new Error(vm.$t(i18nKey)))
          } else {
            callback()
          }
        }
      }
    }

    Vue.prototype.createRequiredRule2 = function(vm, i18nKey, trigger = ['blur', 'change'],type) {
      return {
        required: true,
        trigger,
        validator: (rule, value, callback) => {
          if (!value) {
            callback()
            return
          } 
          let reg
          if (type === 'url') {
            reg = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/
          } else if (type === 'email') {
            reg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
          }
          if (!reg.test(value)) {
            callback(new Error(vm.$t(i18nKey)))
            return
          }
          callback()
        }
      }
    }

    Vue.prototype.refreshFormValidateOnLocaleChange = function(vm, formRefs = []) {
      vm.$nextTick(() => {
        formRefs.forEach(refName => {
          const form = vm.$refs[refName]
          if (!form || !form.fields) return
          form.fields.forEach(field => {
            if (field.validateState === 'error' && field.prop) {
              form.validateField(field.prop, () => {})
            }
          })
        })
      })
    }
  },
}
